var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "60 60 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.665,271.729c-38.672,0-70.135-31.459-70.135-70.129c0-38.672,31.462-70.135,70.135-70.135   c38.672,0,70.134,31.462,70.134,70.135C323.799,240.27,292.337,271.729,253.665,271.729z M253.665,154.466   c-25.99,0-47.135,21.145-47.135,47.135c0,25.987,21.145,47.129,47.135,47.129c25.989,0,47.134-21.142,47.134-47.129   C300.799,175.61,279.655,154.466,253.665,154.466z M256,54.872c-83.352,0-151.162,67.811-151.162,151.162c0,134.032,136.018,239.518,141.809,243.945l9.354,7.148l9.348-7.148  c5.791-4.428,141.814-109.913,141.814-243.945C407.162,122.682,339.353,54.872,256,54.872z M255.989,417.763  c-29.792-25.637-120.352-111.815-120.352-211.729c0-66.37,53.987-120.363,120.363-120.363c66.364,0,120.363,53.994,120.363,120.363  C376.364,305.734,285.768,392.086,255.989,417.763z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0c3cbfaa.svg";
export { ForwardRef as ReactComponent };